import androidx.compose.runtime.Composable
import androidx.compose.runtime.ComposeNode
import kotlinx.browser.document
import org.jetbrains.compose.web.internal.runtime.ComposeWebInternalApi
import org.jetbrains.compose.web.internal.runtime.DomApplier
import org.jetbrains.compose.web.internal.runtime.DomNodeWrapper
import org.w3c.dom.Element

@OptIn(ComposeWebInternalApi::class)
@Composable
fun Html(value: String) {
    ComposeNode<DomNodeWrapper, DomApplier>(
        factory = { DomNodeWrapper(document.createElement("div")) },
        update = {
            set(value) { value -> (node as Element).innerHTML = value }
        },
    )
}